import { useExperiments } from './context';
import { ExperimentVariant } from './types';

export function useFlag(
  flagKey: string,
  defaultValue: string | number | boolean
): {
  value: string | number | boolean;
  variant: ExperimentVariant | null;
} {
  const { flags } = useExperiments();

  const variant = flags[flagKey] || null;
  const value = variant?.value ?? defaultValue;

  return {
    value,
    variant,
  };
}
